// extracted by mini-css-extract-plugin
export var marginNegative = "_62-5 _62-3 _62-1";
export var marginPositive = "_62-4 _62-3 _62-1";
export var modalContent = "_62-6";
export var samplesTable = "_62-8";
export var samplesTableContainer = "_62-7";
export var statBox = "_62-a";
export var tableCell = "_62-1";
export var tableCellCenter = "_62-2 _62-1";
export var tableCellRight = "_62-3 _62-1";
export var tableHeader = "_62-0";
export var trackingNumber = "_62-9";